var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.027 9.03332C11.747 9.30665 11.587 9.69999 11.627 10.12C11.687 10.84 12.347 11.3666 13.067 11.3666H14.3337V12.16C14.3337 13.54 13.207 14.6667 11.827 14.6667H4.17366C2.79366 14.6667 1.66699 13.54 1.66699 12.16V7.67333C1.66699 6.29333 2.79366 5.16666 4.17366 5.16666H11.827C13.207 5.16666 14.3337 6.29333 14.3337 7.67333V8.63333H12.987C12.6137 8.63333 12.2737 8.77998 12.027 9.03332Z",
    stroke: "#495057",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 8.27337V5.22674C1.66699 4.4334 2.15366 3.72671 2.89366 3.44671L8.18699 1.44671C9.01366 1.13337 9.90033 1.74673 9.90033 2.63339V5.16672",
    stroke: "#495057",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0395 9.31343V10.6868C15.0395 11.0535 14.7462 11.3534 14.3729 11.3668H13.0662C12.3462 11.3668 11.6862 10.8401 11.6262 10.1201C11.5862 9.70011 11.7462 9.30677 12.0262 9.03344C12.2729 8.7801 12.6129 8.63345 12.9862 8.63345H14.3729C14.7462 8.64679 15.0395 8.94676 15.0395 9.31343Z",
    stroke: "#495057",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 8H9.33366",
    stroke: "#495057",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.133761b22abb7bda756669f6f1173073.svg";
export { ForwardRef as ReactComponent };